import React, {useState} from "react";
import { Container, Navbar,Nav } from 'react-bootstrap';
import "./Home.css";
import logo from "../img/logo.png";
import resume from "../img/ResumeF.pdf"
import About from './../About';
import { NavLink } from 'react-router-dom';
import Service from "../Service";
import Project from './../Project';
import Contact from './../Contact';
import Footer from './../Footer';
import Skills from "../Skills/Skills";

function Home() {
 const download=()=>{
  
 }

  
  return (
    <>
    <Navbar className="py-3" collapseOnSelect fixed="top"  expand="lg" bg="dark" variant="dark" classNam="header">
            <Container>
            <Navbar.Brand href="#home"><div class="logo">PORTFOLIO</div></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto">

                </Nav>
                <Nav>
                    <NavLink to="/home"  href="#home" className="mt-2">Home</NavLink>
                    <Nav.Link  href="#about" >About</Nav.Link>
                    <Nav.Link href="#services">Services</Nav.Link>
                    <Nav.Link href="#skills">skills</Nav.Link>
                    <Nav.Link href="#contract">Contract</Nav.Link>
                </Nav>
            </Navbar.Collapse>
            </Container>
            </Navbar>
    <div className="home" id="home">
    
      <div className="home__bg">
       
        {/* HOME CONTENT */}
        <div className="container">
          <div className="home__content row">
            <div className="home__meta col-lg-6">
              <h1 className="home__text pz__10">WELCOME TO MY WORLD</h1>
              <h2 className="home__text pz__10">Hi, I’m  Mahmud</h2>
              <h3 className="home__text sweet pz__10">MERN Developer.</h3>
            
             <a target="_blank" href={resume} > <button className="about btn pointer mt-3">Download Cv </button> </a>
            </div>
            <div className="col-lg-6" style={{marginTop:"-30px"}}>
            <img className="img-fluid w-75" src="https://i.ibb.co/XyY4fnk/b1.png" />
          </div>
          </div>
         
        </div>
      </div>
    </div>
    
     <About></About>
     <Skills></Skills>
     <Service></Service>
     <Project />
       <Contact />
       <Footer />
    </>
  );
}

export default Home;
